<template>
	<div class="float-consult">
		<!-- 电话咨询 -->
		<div class="float-item" @mouseenter="showPhone = true" @mouseleave="showPhone = false">
			<div class="float-btn">
				<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2">
					<path
						d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.362 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.338 1.85.573 2.81.7A2 2 0 0122 16.92z" />
				</svg>
			</div>
			<transition name="fade">
				<div class="float-pop" v-show="showPhone">
					<div class="pop-title">电话咨询</div>
					<div class="pop-value">{{ phone }}</div>
					<a :href="'tel:' + phone" class="pop-link">一键拨号</a>
				</div>
			</transition>
		</div>

		<!-- 微信咨询 -->
		<div class="float-item" @mouseenter="showWechat = true" @mouseleave="showWechat = false">
			<div class="float-btn">
				<svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor">
					<path
						d="M8.691 2.188C3.891 2.188 0 5.476 0 9.53c0 2.212 1.17 4.203 3.002 5.55a.59.59 0 01.213.665l-.39 1.48c-.019.07-.048.141-.048.213 0 .163.13.295.29.295a.326.326 0 00.167-.054l1.903-1.114a.864.864 0 01.717-.098 10.16 10.16 0 002.837.403c.276 0 .543-.027.811-.05-.857-2.578.157-4.972 1.932-6.446 1.703-1.415 3.882-1.98 5.853-1.838-.576-3.583-4.196-6.348-8.596-6.348zM5.785 5.991c.678 0 1.227.549 1.227 1.227 0 .677-.549 1.226-1.227 1.226a1.227 1.227 0 010-2.453zm5.892 0c.678 0 1.227.549 1.227 1.227 0 .677-.549 1.226-1.227 1.226a1.227 1.227 0 010-2.453z" />
					<path
						d="M17.293 9.754c-3.388 0-6.134 2.265-6.134 5.06 0 2.494 1.91 4.243 3.753 4.954.17.065.31.07.37.018.06-.053.638-.403.638-.403.064-.04.146-.03.198.01a7.319 7.319 0 002.378.338c.503 0 1.004-.05 1.495-.15a.694.694 0 01.188.01l1.495.875a.27.27 0 00.138.043.239.239 0 00.238-.24c0-.056-.024-.116-.04-.173l-.311-1.186a.486.486 0 01.175-.534C23.873 17.643 24 16.228 24 14.813c0-2.794-3.003-5.06-6.707-5.06zm-3.393 2.366c.509 0 .918.412.918.92a.919.919 0 01-.918.92.919.919 0 01-.919-.92c0-.508.41-.92.919-.92zm4.903 1.84a.919.919 0 01-.918-.92c0-.508.41-.92.918-.92.508 0 .919.412.919.92a.919.919 0 01-.919.92z" />
				</svg>
			</div>
			<transition name="fade">
				<div class="float-pop wechat-pop" v-show="showWechat">
					<div class="pop-title">微信咨询</div>
					<img v-if="wechatQr" :src="wechatQr" alt="微信二维码" class="qr-img" />
					<div v-else class="qr-placeholder">
						<svg viewBox="0 0 24 24" width="40" height="40" fill="currentColor" opacity="0.3">
							<path d="M3 3h7v7H3V3zm11 0h7v7h-7V3zM3 14h7v7H3v-7zm11 0h7v7h-7v-7z" />
						</svg>
						<span>请上传微信二维码</span>
					</div>
					<div class="pop-sub" v-if="wechatId">微信号：{{ wechatId }}</div>
				</div>
			</transition>
		</div>

		<!-- 回到顶部 -->
		<div class="float-item" v-show="showBackTop" @click="scrollToTop">
			<div class="float-btn">
				<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2">
					<path d="M12 19V5M5 12l7-7 7 7" />
				</svg>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'FloatingConsult',
		props: {
			phone: {
				type: String,
				default: '400-800-2026'
			},
			wechatQr: {
				type: String,
				default: ''
			},
			wechatId: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				showPhone: false,
				showWechat: false,
				showBackTop: false
			}
		},
		mounted() {
			window.addEventListener('scroll', this.onScroll)
			this.onScroll()
		},
		beforeDestroy() {
			window.removeEventListener('scroll', this.onScroll)
		},
		methods: {
			onScroll() {
				this.showBackTop = window.scrollY > 400
			},
			scrollToTop() {
				window.scrollTo({ top: 0, behavior: 'smooth' })
			}
		}
	}
</script>

<style scoped>
	.float-consult {
		position: fixed;
		right: 16px;
		bottom: 12%;
		z-index: 100;
		display: flex;
		flex-direction: column;
		gap: 10px;
	}

	.float-item {
		position: relative;
	}

	.float-btn {
		width: 48px;
		height: 48px;
		border-radius: 50%;
		background: linear-gradient(135deg, var(--main), var(--deep));
		color: #fff;
		display: grid;
		place-items: center;
		cursor: pointer;
		box-shadow: 0 6px 20px rgba(7, 52, 67, 0.3);
		transition: transform 0.25s, box-shadow 0.25s;
	}

	.float-btn:hover {
		transform: scale(1.08);
		box-shadow: 0 10px 30px rgba(7, 52, 67, 0.4);
	}

	.float-pop {
		position: absolute;
		right: 62px;
		top: 50%;
		transform: translateY(-50%);
		background: #fff;
		border-radius: 8px;
		box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
		padding: 18px 22px;
		white-space: nowrap;
		min-width: 170px;
	}

	.float-pop::after {
		content: "";
		position: absolute;
		right: -8px;
		top: 50%;
		transform: translateY(-50%);
		border: 8px solid transparent;
		border-right: 0;
		border-left-color: #fff;
	}

	.wechat-pop {
		min-width: 200px;
	}

	.pop-title {
		font-size: 14px;
		color: #6c7a80;
		margin-bottom: 6px;
	}

	.pop-value {
		font-size: 20px;
		font-weight: 700;
		color: var(--deep);
		margin-bottom: 8px;
	}

	.pop-link {
		display: inline-block;
		font-size: 13px;
		color: var(--main);
		text-decoration: underline;
	}

	.pop-sub {
		margin-top: 8px;
		font-size: 13px;
		color: #6c7a80;
	}

	.qr-img {
		width: 140px;
		height: 140px;
		display: block;
		margin: 6px 0;
	}

	.qr-placeholder {
		width: 140px;
		height: 140px;
		display: grid;
		place-items: center;
		background: #f4f7fb;
		color: #6c7a80;
		font-size: 12px;
		margin: 6px 0;
		text-align: center;
		gap: 6px;
	}

	.fade-enter-active,
	.fade-leave-active {
		transition: opacity 0.2s;
	}

	.fade-enter,
	.fade-leave-to {
		opacity: 0;
	}
</style>
